// extracted by mini-css-extract-plugin
module.exports = {"article":"typography_article__ow4yh","slide":"typography_slide__zlHA0"};